import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCheckboxChecked = props => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="m16 0h-14c-1.11 0-2 0.9-2 2v14c0 1.1 0.89 2 2 2h14c1.11 0 2-0.9 2-2v-14c0-1.1-0.89-2-2-2zm-9 14-5-5 1.41-1.41 3.59 3.58 7.59-7.59 1.41 1.42-9 9z" />
  </SvgIcon>
);

export default IconCheckboxChecked;



// WEBPACK FOOTER //
// ./src/components/icons/IconCheckboxChecked.js